import { buildQueryHelpers, OperationIds } from '../../util'
import { SingleResourceQueryKey } from '../../util/types'

export type BoardKey = SingleResourceQueryKey<OperationIds.ReadBoardV3>

export const readBoard = buildQueryHelpers<OperationIds.ReadBoardV3, BoardKey>(
  'board',
  OperationIds.ReadBoardV3
)
